var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "popup_wrap", staticStyle: { width: "1000px" } },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          staticStyle: { top: "20px" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c(
        "form",
        { staticStyle: { "margin-top": "-18px" }, attrs: { id: "mailFrm" } },
        [
          _c("div", { staticClass: "popup_cont" }, [
            _c("h1", { staticClass: "page_title" }, [
              _vm._v(_vm._s(_vm.couponNm)),
            ]),
            _c(
              "div",
              { staticClass: "content_box", staticStyle: { height: "100%" } },
              [
                _c("table", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        ref: "couponMsg1",
                        staticStyle: {
                          "font-weight": "400",
                          "font-size": "large",
                        },
                      },
                      [_vm._v(_vm._s(_vm.couponMsg1))]
                    ),
                    _c(
                      "th",
                      {
                        ref: "couponMsg2",
                        staticStyle: {
                          "font-size": "large",
                          "font-weight": "400",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.couponMsg2) + " ")]
                    ),
                    _c(
                      "th",
                      {
                        ref: "couponMsg3",
                        staticStyle: {
                          "font-weight": "400",
                          "font-size": "large",
                        },
                      },
                      [_vm._v(_vm._s(_vm.couponMsg3))]
                    ),
                    _c(
                      "th",
                      {
                        ref: "couponMsg4",
                        staticStyle: {
                          "font-size": "large",
                          "font-weight": "400",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.couponMsg4))]
                    ),
                  ]),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.couponMsg5.length > 0,
                          expression: "couponMsg5.length > 0",
                        },
                      ],
                    },
                    [
                      _c(
                        "td",
                        {
                          ref: "couponMsg5",
                          staticStyle: {
                            "font-size": "medium",
                            "font-weight": "400",
                          },
                          attrs: { colspan: "4" },
                        },
                        [_vm._v(_vm._s(_vm.couponMsg5))]
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "content_box",
                    staticStyle: {
                      "padding-top": "7px",
                      height: "100%",
                      "background-color": "#F0F5FF",
                    },
                  },
                  [
                    _c(
                      "table",
                      { staticStyle: { width: "98%", "margin-left": "8" } },
                      [
                        _c("tbody", { staticStyle: { border: "0px" } }, [
                          _c(
                            "tr",
                            _vm._l(
                              _vm.couponProgressPoint,
                              function (item, lvlDiv) {
                                return _c(
                                  "th",
                                  {
                                    key: lvlDiv,
                                    staticStyle: {
                                      "font-size": "smaller",
                                      "text-align": "-webkit-center",
                                      "background-color": "white",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "font-size": "smaller",
                                          "text-align": "right",
                                          "border-top": "0px",
                                          opacity: "70%",
                                          "background-color": "#F0F5FF",
                                        },
                                        style: {
                                          color:
                                            item === "●" ? "red" : "#F0F5FF",
                                        },
                                      },
                                      [_vm._v(_vm._s(item))]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "content_box",
                        staticStyle: {
                          padding: "7px",
                          "margin-top": "0px",
                          height: "100%",
                          "background-color": "#F0F5FF",
                        },
                      },
                      [
                        _c("table", { staticStyle: { width: "100%" } }, [
                          _c("tbody", { staticStyle: { border: "0px" } }, [
                            _c(
                              "tr",
                              _vm._l(
                                _vm.couponProgress,
                                function (item, lvlDiv) {
                                  return _c(
                                    "th",
                                    {
                                      key: lvlDiv,
                                      staticStyle: {
                                        "font-size": "smaller",
                                        "text-align": "-webkit-center",
                                        "background-color": "#F0F5FF",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            height: "24px",
                                            "text-align": "right",
                                            "border-top": "0px",
                                            opacity: "70%",
                                            color: "rgba(255, 141, 40)",
                                            "background-color":
                                              "rgba(255, 141, 40)",
                                          },
                                          style: {
                                            visibility:
                                              item === "1"
                                                ? "hidden"
                                                : "visible",
                                          },
                                        },
                                        [_vm._v(_vm._s(item))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "table",
                      {
                        staticClass: "tbl_list mt10",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c(
                          "tbody",
                          {
                            staticStyle: {
                              "border-left": "2px solid #F0F5FF",
                              "border-right": "2px solid #F0F5FF",
                              "border-bottom": "2px solid #F0F5FF",
                            },
                          },
                          [
                            _c(
                              "tr",
                              {
                                staticStyle: {
                                  height: "50px",
                                  "border-top": "2px solid #F0F5FF",
                                },
                              },
                              [
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      "border-right": "2px solid #F0F5FF",
                                      width: "150px",
                                      "padding-left": "10px",
                                      "font-size": "large",
                                      color: "black",
                                      "background-color": "rgba(229, 238, 255)",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("msg.COUP100.015")))]
                                ),
                                _c(
                                  "th",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.couponLevelList[0].dcRate !==
                                          undefined,
                                        expression:
                                          "couponLevelList[0].dcRate !== undefined",
                                      },
                                    ],
                                    staticStyle: {
                                      "border-right": "2px solid #F0F5FF",
                                      "padding-left": "10px",
                                      "font-size": "large",
                                      color: "black",
                                      "background-color": "rgba(229, 238, 255)",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("msg.COUP100.016")))]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      "border-right": "2px solid #F0F5FF",
                                      "padding-left": "10px",
                                      "font-size": "large",
                                      color: "black",
                                      "background-color": "rgba(229, 238, 255)",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("msg.COUP100.017")))]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticStyle: {
                                      "padding-left": "10px",
                                      "font-size": "large",
                                      color: "black",
                                      "background-color": "rgba(229, 238, 255)",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("msg.COUP100.019")) +
                                        " " +
                                        _vm._s(_vm.$t("msg.COUP100.018"))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._l(
                              _vm.couponLevelList,
                              function (item, lvlDiv) {
                                return _c(
                                  "tr",
                                  {
                                    key: lvlDiv,
                                    staticStyle: {
                                      height: "50px",
                                      "border-top": "2px solid #F0F5FF",
                                    },
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticStyle: {
                                          "border-right": "2px solid #F0F5FF",
                                          "font-weight": "500",
                                          "font-size": "large",
                                          "border-top": "0px",
                                          color: "black",
                                          "background-color": "white",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.lvlNm))]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.couponLevelList[0].dcRate !==
                                              undefined,
                                            expression:
                                              "couponLevelList[0].dcRate !== undefined",
                                          },
                                        ],
                                        staticStyle: {
                                          "border-right": "2px solid #F0F5FF",
                                          "padding-right": "10px",
                                          "font-weight": "500",
                                          "text-align": "right",
                                          "font-size": "large",
                                          "border-top": "0px",
                                          color: "black",
                                          "background-color": "white",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.dcRate) + "%")]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticStyle: {
                                          "border-right": "2px solid #F0F5FF",
                                          "padding-right": "10px",
                                          "font-weight": "500",
                                          "text-align": "right",
                                          "font-size": "large",
                                          "border-top": "0px",
                                          color: "black",
                                          "background-color": "white",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "$ " + _vm._s(item.dc20Max) + "/TEU"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "th",
                                      {
                                        staticStyle: {
                                          "border-right": "2px solid #F0F5FF",
                                          "padding-right": "10px",
                                          "font-weight": "500",
                                          "text-align": "right",
                                          "font-size": "large",
                                          "border-top": "0px",
                                          color: "black",
                                          "background-color": "white",
                                        },
                                      },
                                      [_vm._v(_vm._s(item.targetTeu) + " TEU")]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "content_box",
                        staticStyle: {
                          height: "100%",
                          "background-color": "#F0F5FF",
                        },
                      },
                      [
                        _c("div", { staticClass: "flex_box ml30" }, [
                          _c("div", { staticStyle: { width: "610px" } }, [
                            _c(
                              "li",
                              { staticStyle: { "font-size": "medium" } },
                              [_vm._v(_vm._s(_vm.$t("msg.COUP100.090")))]
                            ),
                          ]),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "button blue lg ml10",
                                staticStyle: { height: "32px", width: "150px" },
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.promotionLink()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("msg.COUP100.038")))]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }